import React from "react";
import pt from "date-fns/locale/pt"; // the locale you want
import BetterCalendar from "../Contrato/BetterCalendar";
import { registerLocale } from "react-datepicker";
import MaskedTextInput from "react-text-mask";

registerLocale("pt", pt);

export const DateInput = (props) => (
  <BetterCalendar
    className={"form-control " + (props.className || "")}
    locale={pt}
    showLeadingZeros={true}
    placeholderText="-- / -- / ----"
    dateFormat="dd/MM/yyyy"
    customInput={
      <MaskedTextInput
        mask={[/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]}
      />
    }
    {...props}
  />
);
